__turbopack_context__.v({
  "act": "ReferenceExperience-module__lcKpuq__act",
  "aiNotice": "ReferenceExperience-module__lcKpuq__aiNotice",
  "assistant": "ReferenceExperience-module__lcKpuq__assistant",
  "breadcrumb": "ReferenceExperience-module__lcKpuq__breadcrumb",
  "breadcrumbIn": "ReferenceExperience-module__lcKpuq__breadcrumbIn",
  "captionIn": "ReferenceExperience-module__lcKpuq__captionIn",
  "dialogIn": "ReferenceExperience-module__lcKpuq__dialogIn",
  "dockSlot": "ReferenceExperience-module__lcKpuq__dockSlot",
  "dots": "ReferenceExperience-module__lcKpuq__dots",
  "edge": "ReferenceExperience-module__lcKpuq__edge",
  "edgeLeft": "ReferenceExperience-module__lcKpuq__edgeLeft",
  "edgeRight": "ReferenceExperience-module__lcKpuq__edgeRight",
  "exchangeLog": "ReferenceExperience-module__lcKpuq__exchangeLog",
  "experience": "ReferenceExperience-module__lcKpuq__experience",
  "explorer": "ReferenceExperience-module__lcKpuq__explorer",
  "explorerCanvas": "ReferenceExperience-module__lcKpuq__explorerCanvas",
  "explorerClose": "ReferenceExperience-module__lcKpuq__explorerClose",
  "explorerIn": "ReferenceExperience-module__lcKpuq__explorerIn",
  "explorerScroll": "ReferenceExperience-module__lcKpuq__explorerScroll",
  "fade": "ReferenceExperience-module__lcKpuq__fade",
  "help": "ReferenceExperience-module__lcKpuq__help",
  "helpGroups": "ReferenceExperience-module__lcKpuq__helpGroups",
  "kbdCluster": "ReferenceExperience-module__lcKpuq__kbdCluster",
  "lensSlot": "ReferenceExperience-module__lcKpuq__lensSlot",
  "living": "ReferenceExperience-module__lcKpuq__living",
  "mobileAsk": "ReferenceExperience-module__lcKpuq__mobileAsk",
  "mobileBar": "ReferenceExperience-module__lcKpuq__mobileBar",
  "mobileControlGrid": "ReferenceExperience-module__lcKpuq__mobileControlGrid",
  "mobileDeconstruct": "ReferenceExperience-module__lcKpuq__mobileDeconstruct",
  "mobileGuide": "ReferenceExperience-module__lcKpuq__mobileGuide",
  "mobileHeader": "ReferenceExperience-module__lcKpuq__mobileHeader",
  "mobileIndex": "ReferenceExperience-module__lcKpuq__mobileIndex",
  "mobileLens": "ReferenceExperience-module__lcKpuq__mobileLens",
  "mobileSceneControls": "ReferenceExperience-module__lcKpuq__mobileSceneControls",
  "mobileStrip": "ReferenceExperience-module__lcKpuq__mobileStrip",
  "parallax": "ReferenceExperience-module__lcKpuq__parallax",
  "persistentStatus": "ReferenceExperience-module__lcKpuq__persistentStatus",
  "personaChips": "ReferenceExperience-module__lcKpuq__personaChips",
  "push": "ReferenceExperience-module__lcKpuq__push",
  "pushActive": "ReferenceExperience-module__lcKpuq__pushActive",
  "rowIn": "ReferenceExperience-module__lcKpuq__rowIn",
  "sceneMap": "ReferenceExperience-module__lcKpuq__sceneMap",
  "scrim": "ReferenceExperience-module__lcKpuq__scrim",
  "scrimIn": "ReferenceExperience-module__lcKpuq__scrimIn",
  "semanticCanvas": "ReferenceExperience-module__lcKpuq__semanticCanvas",
  "semanticStage": "ReferenceExperience-module__lcKpuq__semanticStage",
  "sheet": "ReferenceExperience-module__lcKpuq__sheet",
  "sheetActions": "ReferenceExperience-module__lcKpuq__sheetActions",
  "sheetHandle": "ReferenceExperience-module__lcKpuq__sheetHandle",
  "sheetIn": "ReferenceExperience-module__lcKpuq__sheetIn",
  "skipLink": "ReferenceExperience-module__lcKpuq__skipLink",
  "slide": "ReferenceExperience-module__lcKpuq__slide",
  "slideExplore": "ReferenceExperience-module__lcKpuq__slideExplore",
  "slideIndex": "ReferenceExperience-module__lcKpuq__slideIndex",
  "slideNeon": "ReferenceExperience-module__lcKpuq__slideNeon",
  "srOnly": "ReferenceExperience-module__lcKpuq__srOnly",
  "srTranscript": "ReferenceExperience-module__lcKpuq__srTranscript",
  "sweep": "ReferenceExperience-module__lcKpuq__sweep",
  "toast": "ReferenceExperience-module__lcKpuq__toast",
  "toastIn": "ReferenceExperience-module__lcKpuq__toastIn",
  "tourBar": "ReferenceExperience-module__lcKpuq__tourBar",
  "tourBarIn": "ReferenceExperience-module__lcKpuq__tourBarIn",
  "tourCaption": "ReferenceExperience-module__lcKpuq__tourCaption",
  "tourFill": "ReferenceExperience-module__lcKpuq__tourFill",
  "tourTrack": "ReferenceExperience-module__lcKpuq__tourTrack",
  "veil": "ReferenceExperience-module__lcKpuq__veil",
  "viewport": "ReferenceExperience-module__lcKpuq__viewport",
});
